import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: 480,
    margin: '0 auto',
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(10),
    boxSizing: 'border-box',
  },
  title: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(0.5),
  },
}));
